(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'manualMessageTrigger'
        })
        
        .controller('ManualMessageTriggerController', ManualMessageTriggerController);

    ManualMessageTriggerController.$inject = ['ManualMessageTriggerService'];

    function ManualMessageTriggerController(ManualMessageTriggerService) {

       var vm = this;

       vm.messageTypeList = [
            "OrderResponse",
            "TradeResponse",
            "LimitUtilisationUpdate",
            "GetFillArrayIndexes",
            "GetInstrumentIndexes",
            "GetDailyClosingPriceDetails",
            "GetPendingOrderFromArray",
            "GetLTPPrices",
            "UpdateDailyClosingPrice",
            "UpdatePendingOrderArray",
            "UpdateSessionStatus",
            "UpdateSODStatus",
            "CancelPushMessage",
            "ClearMarketMovementRequests",
            "ClearOrderActivityRequests",
            "GetFileFormat",
            "OrderActivityResponse",
        ];

        vm.isJson = true; // Default to true

        function sendManualTrigger() {

            if (!vm.messageType) {
                vm.responseJson = 'Please select a message type.';
                return;
            }

            var requestData;

            if(vm.isJson)
            {
                try {
                    requestData = JSON.parse(vm.requestJson);
                } catch (error) {
                    vm.responseJson = 'Invalid JSON: ' + error.message;
                    return;
                }
            }
            else
            {
                requestData = {};
            }

            ManualMessageTriggerService.sendManualTrigger(
                {
                    messageType: vm.messageType
                },
                requestData,
                processSuccessResponse,
                processFailureResponse
            );

            // request.$promise.then(
            //     function(response) {
            //         console.log('Success response:', response);
            //     },
            //     function(error) {
            //         console.log('Error response:', error);
            //     }
            // );

            // request.$promise.catch(processFailureResponse);

        }

        // function processSuccessResponse(response) {

        //     console.log('FULL RESPONSE:', response);
        //     console.log('TYPE:', typeof response);
        //     console.log('ARRAY:', angular.isArray(response));

        //     if (angular.isArray(response)) {
        //         vm.responseJson = response.join('');
        //     } else {
        //         vm.responseJson = response;
        //     }

        //     // vm.responseJson = response || "Response Data";
        // }

        // function processFailureResponse(error) {
        //     console.log('Manual trigger error:', error);
        //     console.log('Error data:', error.data);

        //     vm.responseJson = error.data || 'Request failed';
        // }

        function processSuccessResponse(responseData) {
            vm.responseJson = responseData.response;
        }

        function processFailureResponse(error) {
            console.log('Manual trigger error:', error);

            if (error.data && error.data.response) {
                vm.responseJson = error.data.response;
            } else {
                vm.responseJson = 'Request failed';
            }
        }

        vm.sendManualTrigger = sendManualTrigger;

        // callAlert();

        // function callAlert()
        // {
        //     window.alert("Message");
        // }

    }
})();
    